export default __webpack_public_path__ + "static/media/CRToroOpen.15150c13.jpg";